var map = {
	"./AnnotationGoalStrategy": [
		1852
	],
	"./AnnotationGoalStrategy.tsx": [
		1852
	],
	"./DoubleMultioptions": [
		93584,
		584
	],
	"./DoubleMultioptions.tsx": [
		93584,
		584
	],
	"./GoalFallback": [
		68739,
		739
	],
	"./GoalFallback.tsx": [
		68739,
		739
	],
	"./Multioptions": [
		46047,
		47
	],
	"./Multioptions.tsx": [
		46047,
		47
	],
	"./PlainText": [
		68317,
		317
	],
	"./PlainText.tsx": [
		68317,
		317
	],
	"./RadioButtonOptions": [
		15803,
		803
	],
	"./RadioButtonOptions.tsx": [
		15803,
		803
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71188;
module.exports = webpackAsyncContext;